import Swiper from 'swiper';

$(function () {
    var eshopsTrustSliderSwiper = new Swiper('[data-selector="reference-slider-swiper"]', {
        slidesPerView: 5,
        spaceBetween: 30,
        centeredSlides: true,
        initialSlide: 2,
        simulateTouch: false,
        nextButton: '[data-selector="reference-slider-next-btn"]',
        prevButton: '[data-selector="reference-slider-prev-btn"]',
        pagination: '[data-selector="reference-slider-pagination"]',
        paginationClickable: true,
        breakpoints: {
            959: {
                slidesPerView: 3,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 1,
            },
            493: {
                slidesPerView: 1.6,
                spaceBetween: 10,
                centeredSlides: true,
                initialSlide: 1,
            },
            399: {
                slidesPerView: 1.4,
                spaceBetween: 10,
                centeredSlides: true,
                initialSlide: 1,
            },
        }
    });
});